import { apiClient } from "../api";

export const loginAdmin = async (credentials) => {
  const res = await apiClient.post("/login", credentials);
  return res.data;
};